// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M3 1H15.4142L21 6.58579V12.6713C20.175 11.6518 18.9136 11 17.5 11C15.0147 11 13 13.0147 13 15.5V21.5C13 22.026 13.0902 22.5308 13.2561 23H3V1ZM14.5 3V7.5H19L14.5 3Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M17.5 13C16.1193 13 15 14.1193 15 15.5V20C15 22.2091 16.7909 24 19 24C21.2091 24 23 22.2091 23 20V15.5H21V20C21 21.1046 20.1046 22 19 22C17.8954 22 17 21.1046 17 20V15.5C17 15.2239 17.2239 15 17.5 15C17.7761 15 18 15.2239 18 15.5V20H20V15.5C20 14.1193 18.8807 13 17.5 13Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-file-attachment-filled')
export default class FileAttachmentFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'file-attachment-filled',
    }
  }
}
